<template>
  <div class="mypage-template" theme>
    <div id="mypage-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'user',
      parts: [
        {
          elem: '#mypage-content',
          htmlFile: 'mypage'
        }
      ]
    }
  }
}
</script>
